import { render } from "./SkeletonPointSelect.vue?vue&type=template&id=ff80d704&scoped=true"
import script from "./SkeletonPointSelect.vue?vue&type=script&lang=js"
export * from "./SkeletonPointSelect.vue?vue&type=script&lang=js"

import "./SkeletonPointSelect.vue?vue&type=style&index=0&id=ff80d704&lang=css"
import "./SkeletonPointSelect.vue?vue&type=style&index=1&id=ff80d704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff80d704"]])

export default __exports__